import type { OrderAction, StatusOut } from '../ecommerce/generated.codegen';

export interface OrderList {
  id: string | undefined | null,
  number: {
    order_id: string | undefined | null,
    innova_id: string | undefined | null
  },
  clientName: string | undefined | null,
  total_value: number | string | undefined | null,
  payment_method: string | undefined | null,
  request_made_date: string | undefined | null,
  seller: string | undefined | null,
  partner_name: string | undefined | null,
  inverter_type?: string,
  status: StatusOut | undefined | null,
  actions: Array<OrderAction | null> | undefined | null,
  deliveries?: Array<{ id?: string | null } | null>,
  tracking_link?: string | null
}

export enum CustomerOrder {
  NATURAL_PERSON = 'NATURAL_PERSON',
}
